import type { ReactNode } from 'react';
import { useCapabilities } from '../../lib/capabilities';

// PermissionGate (P01 §4.3) — renders children only when the principal holds a
// permission. Otherwise renders `fallback` (e.g. a PlanTeaser or a disabled
// control with a tooltip), or nothing when `hide`. Never trusts itself — the
// server re-checks every call. Renders the fallback/nothing until hydrated.
export interface PermissionGateProps {
  need: string;
  children: ReactNode;
  fallback?: ReactNode;
  hide?: boolean;
}

export function PermissionGate({ need, children, fallback = null, hide = false }: PermissionGateProps): JSX.Element {
  const { hasPermission, isHydrated } = useCapabilities();

  if (isHydrated && hasPermission(need)) return <>{children}</>;
  return <>{hide ? null : fallback}</>;
}
